<template>
    <div class="homebg">
         <!-- <div class="home_top">
              <div class="home_top_img"><img src="../assets/img/home.png" /></div>
              <div class="personal">
                <el-dropdown :show-timeout="0" size="small" placement="bottom" >
                  <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
                    <div class="user_img">
                      <img v-if="userImg && userImg != 'null'"
                          :src="userImg"
                          style="height: 40px; width:40px; border-radius: 50% 50%"/>
                      <img
                        v-else
                        style="height: 40px"
                        src="../assets/img/default-header.png"
                        :alt="userName"
                      />
                    </div>
                    <span style="color: white;margin-left: 10px">{{userName}}</span>
                  </div>
  
                  <el-dropdown-menu slot="dropdown" style="width: 110px">
                    <el-dropdown-item @click.native="userMessage()">个人信息</el-dropdown-item>
                    <el-dropdown-item @click.native="logoutHandle()">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
         </div> -->
         <!--end-->
         <div class="home_center">
              <div class="bg_1">
                  <img src="../assets/img/set.png" />
                  <div class="txt" style="">功能开发中，敬请期待~</div>
                  <div class="back" @click="handleBack()">返回</div>
              </div>
         </div>
  
    </div> 
  </template>
  <script>
  import Vue from "vue";
  import { loginOut, listApplication, bindingPcWechat } from "@/api/api";
  import { clearLoginInfo } from "@/utils";
  import wxlogin from "vue-wxlogin";
  export default {
    data() {
      return {
        imgUrl: process.env.IMG_SHOW_URL + "/",
  
        userImg: this.$cookie.get("headImg"),
        userName: this.$cookie.get("name"),
        typeLists: ["全部"],
        typeName: "全部",
        typeIndex: 0,
        title: "",
        appLists: [],
        appLists2: [],
        appLists3: [],
        allApplication: [],
        code: "",
        wxConfig: {
          appid: process.env.WX_APPID,
          wxVisible: false,
        },
      };
    },
    mounted() {
      // this.listApplication();
      if (typeof this.$route.query.returnType != "undefined") {
        let returnType = this.$route.query.returnType;
        this.code = this.$route.query.code;
        if (returnType == "binding") {
          //微信绑定
          this.bindingPcWechat();
        }
      }
    },
    components: {
      wxlogin,
    },
    methods: {
        handleBack(){
            this.$router.push({ path: '/home' })
        },
      bindingPcWechat() {
        bindingPcWechat({
          code: this.code,
          userId: this.$cookie.get("userId"),
        }).then((res) => {
          if (res && res.code === 0) {
            this.$message.success("微信绑定成功");
            this.$cookie.set("pcOpenid", res.data);
            this.wxConfig.wxVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      logoutHandle() {
        loginOut({
          token: this.$cookie.get("token"),
        }).then((res) => {
          if (res && res.code === 0) {
            this.$message.success("退出登录成功");
            clearLoginInfo();
            this.$router.push({ path: "/login" });
          } else {
            this.$message.success("退出登录成功");
            clearLoginInfo();
            this.$router.push({ path: "/login" });
  
          }
        });
      },
      userMessage() {
        this.$router.push({ path: "/personal" });
      },
      changeApp(index) {
        this.typeIndex = index;
        this.typeName = this.typeLists[this.typeIndex];
        this.searchApplication();
      },
      listApplication() {
        listApplication({}).then((res) => {
          if (res && res.code === 0) {
            this.allApplication = res.data;
            if(this.allApplication.length>3){
              for (let i = 0; i < 6; i++) {
                this.appLists.push(this.allApplication[i])
              }
              if(this.allApplication.length>6){
                for (let i = 6; i < 12; i++) {
                  this.appLists2.push(this.allApplication[i])
                }
                for (let i = 12; i < this.allApplication.length; i++) {
                  this.appLists3.push(this.allApplication[i])
                }
              }else{
                for (let i = 3; i < this.allApplication.length; i++) {
                  this.appLists2.push(this.allApplication[i])
                }
              }
            }else{
              this.appLists = this.allApplication
            }
          } else {
            this.$message.error(res.msg);
            this.$router.push({ path: '/login' })
          }
        });
      },
      onApplication(item) {
        if(item.suffix){
          window.location.href = item.url + "?" + item.suffix;
        }else{
          window.location.href = item.url + "?token=" + Vue.cookie.get("token");
        }
      },
    },
  };
  </script>
  <style scoped lang="scss">
  .homebg{
    height: 100%;
    // background-image: url("../assets/newimg/bg1.jpg");
    background: #F6F6F6;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .home_top{
    height: 140px;
    background: rgba(1,49,130,0.8);
    border-radius: 0px 0px 0px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .home_top_img{
      margin-left: 60px;
    }
  }
  .home_center{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .bg_1{
    // background: rgba(2, 51, 132, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
        width: 700px;
    }
    .txt{
      font-size: 20px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #11202D;
        margin-top: 70px;
        margin-bottom: 50px;
    }
    .back{
        width: 200px;
height: 50px;
background: #1573FC;
border-radius: 5px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: center;
font-size: 16px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
cursor: pointer;
    }
    

  }
  .personal {
      right: 45px;
      top: 7px;
      color: #fff;
      height: 60px;
      line-height: 60px;
      margin-right: 60px;
      cursor: pointer;
      .el-dropdown-link {
        width: 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: white;
      }
    }
    .home_center_one{
      display: flex;
      flex-direction: row;
    }
    .setup{
      width: 13.5146vw;
      height: 12.7604vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img{
        width: 70px;
        height: 70px;
      }
      .txt{
        font-size: 26px;
        font-family: PingFang SC-Bold, PingFang SC;
        color: #FFFFFF;
        margin-top: 12px;
      }
    }
    .bg1{
      background: rgba(1, 49, 130, 0.6);
    }
    .bg2{
      background: rgba(21, 115, 252, 0.6);
    }
    .bg3{
      background: rgba(255, 169, 39, 1)
    }
    .bg4{
      background: rgba(27, 99, 183, 0.6)
    }
    
  </style>


// WEBPACK FOOTER //
// src/views/construction.vue